import { render, staticRenderFns } from "./CreateConfiguration.vue?vue&type=template&id=1830d841&scoped=true&"
import script from "./CreateConfiguration.vue?vue&type=script&lang=ts&"
export * from "./CreateConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./CreateConfiguration.vue?vue&type=style&index=0&id=1830d841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830d841",
  null
  
)

export default component.exports